/* unplugin-vue-components disabled */import script from "./RobotArmBottleView.vue?vue&type=script&setup=true&lang=js"
export * from "./RobotArmBottleView.vue?vue&type=script&setup=true&lang=js"

import "./RobotArmBottleView.vue?vue&type=style&index=0&id=4c9e3694&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9e3694"]])

export default __exports__